module.exports = __webpack_public_path__ + "static/img/day3.e384c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour4/day3.jpg
// module id = eH9e
// module chunks = 0